<template>
  <thead>
    <tr>
      <th v-for="head in headers" :key="head.index">
        <span @click="sortBy(head.index)" style="cursor: pointer;" class="d-flex align-items-center">
          <span class="m-r-xs d-flex" v-if="!notSortable.includes(head.index)">
            <i :class="'fa fa-arrow-up-long ' + (currentSort.prop === head.index && currentSort.dir === 1  ? 'fa-lg green' : '')"></i>
            <i :class="'fa fa-arrow-down-long ' + (currentSort.prop === head.index && currentSort.dir === -1  ? 'fa-lg green' : '')"></i>
          </span>
          {{ head.label }}
        </span>
      </th>
    </tr>
  </thead>
</template>
<script>
import { useProjectStore } from '../../../../stores/ProjectStore'

export default {
  setup () {
    const store = useProjectStore()
    return { store }
  },
  props: {
    headers: { type: Array, required: true },
    notSortable: { type: Array, default () { return [] } },
    sortingActionName: { type: String }
  },
  data () {
    return {
      currentSort: {
        prop: '',
        dir: 1
      },
      filtersQuery: ''
    }
  },
  created () {
  },
  methods: {
    sortBy (field) {
      if (this.notSortable.includes(field)) return
      if (this.currentSort.prop === field) {
        this.$set(this.currentSort, 'dir', this.currentSort.dir *= -1)
      } else {
        this.$set(this.currentSort, 'prop', field)
        this.$set(this.currentSort, 'dir', 1)
      }
      this.$emit('triggerSort', {prop: this.currentSort.prop, dir: this.currentSort.dir})
    }
  }
}
</script>
<style scoped>
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/SortByHeaders.vue